import React from 'react';
import MuiPaper, { PaperProps } from '@mui/material/Paper';

export const Paper: React.FC<PaperProps> = (props) => <MuiPaper {...props} />;
